import { render, staticRenderFns } from "./PatientHemoglobinTab.vue?vue&type=template&id=beedc258&"
import script from "./PatientHemoglobinTab.vue?vue&type=script&lang=js&"
export * from "./PatientHemoglobinTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports